/** Common reusable regex patterns across different fields */

export const ONLY_DIGITS_AND_LETTERS_REGEX = /^[a-zA-ZäöüßÄÖÜ0-9 -]*$/
export const ONLY_DIGITS_REGEX = /^\d*$/
export const AT_LEAST_ONE_DIGIT_AND_ONE_LETTER_REGEX = /^(?=.*?[0-9])(?=.*?[A-Za-z]).+$/
